import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetSearchContent,
  searchContent,
} from '@plone/volto/actions/search/search';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { chaveDaGaleria, donoDaSessao } from './chave';
import { temImagem } from './escalas';

// Teto da busca: uma página de evento tem de 10 a 60 fotos.
export const LIMITE = 500;
// Os três primeiros são campos padrão do resumo (plone.restapi + plone.volto);
// o UID, que identifica a foto escolhida, é coluna do catálogo. Na intranet,
// os quatro passam pela lista permitida do agsus.publico (resumo.py) sem
// nenhuma mudança no backend.
const CAMPOS = ['title', 'description', 'image_scales', 'UID'];

// A página onde o bloco está: dentro de um container, `properties` são os
// dados do container e `metadata` é a página. null: página ainda não salva
// (sem endereço). '' é a raiz do site.
export function caminhoDaPagina({ properties, metadata }) {
  const endereco = metadata?.['@id'] || properties?.['@id'];
  return endereco ? flattenToAppURL(endereco) : null;
}

// As imagens de dentro da página, na ordem da tela Conteúdo. Quem busca é a
// galeria (`buscar`); a barra lateral só lê a mesma chave, sem segundo pedido.
export function useImagensDaPagina({ bloco, caminho, buscar = true }) {
  const dispatch = useDispatch();
  // A chave leva o usuário (./chave.js): a resposta atrasada de outra conta
  // cai numa chave que esta não lê.
  const dono = useSelector((s) => donoDaSessao(s.userSession?.token));
  const chave = chaveDaGaleria(bloco, caminho ?? '', dono);

  // Ao sair da página (ou trocar de conta) o que ficou na chave sai da loja.
  useEffect(() => {
    if (!buscar) return undefined;
    return () => dispatch(resetSearchContent(chave));
  }, [dispatch, chave, buscar]);

  useEffect(() => {
    if (!buscar || caminho === null) return;
    dispatch(
      searchContent(
        caminho,
        {
          'path.depth': 1,
          portal_type: 'Image',
          sort_on: 'getObjPositionInParent',
          metadata_fields: CAMPOS,
          b_size: LIMITE,
        },
        chave,
      ),
    );
  }, [dispatch, caminho, chave, buscar]);

  const busca = useSelector((s) => s.search?.subrequests?.[chave]);
  const itens = busca?.items;
  // A ordem é a da busca (a da tela Conteúdo): nada é reordenado aqui.
  const imagens = useMemo(
    () =>
      (itens || []).filter((it) => it['@type'] === 'Image' && temImagem(it)),
    [itens],
  );
  return { chave, busca, imagens };
}
